// extracted by mini-css-extract-plugin
export var copyableField = "_lx-4";
export var customerBadge = "_lx-0";
export var customerInfoTitle = "_lx-2";
export var details = "_lx-1";
export var dropdownContainer = "_lx-5";
export var dropdownImage = "_lx-6";
export var editAssigneeForm = "_lx-a";
export var editButton = "_lx-3";
export var email = "_lx-7";
export var hidden = "_lx-d";
export var input = "_lx-8";
export var saveButton = "_lx-b";
export var shopifyIcon = "_lx-c";
export var suggestionBadge = "_lx-e";
export var suggestionText = "_lx-f";
export var username = "_lx-9";